import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Categories from './components/Categories';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import CatalogueFloat from './components/CatalogueFloat';
import ShopPage from './pages/ShopPage';
import CategoryPage from './pages/CategoryPage';
import CustomisedOrders from './pages/CustomisedOrders';
import './App.css';

const HomePage = () => (
  <>
    <Hero />
    <About />
    <Categories />
    <Contact />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/shop/:categorySlug" element={<CategoryPage />} />
          <Route path="/customised-orders" element={<CustomisedOrders />} />
        </Routes>
        <Footer />
        <CatalogueFloat />
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
